var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"id":"Facebook","style":{"color":"#000"},"d":"M158.081,83.3c0,10.839,0,59.218,0,59.218h-43.385v72.412h43.385v215.183h89.122V214.936h59.805\r\n\t\t\tc0,0,5.601-34.721,8.316-72.685c-7.784,0-67.784,0-67.784,0s0-42.127,0-49.511c0-7.4,9.717-17.354,19.321-17.354\r\n\t\t\tc9.586,0,29.818,0,48.557,0c0-9.859,0-43.924,0-75.385c-25.016,0-53.476,0-66.021,0C155.878-0.004,158.081,72.48,158.081,83.3z"})));
}

Facebook.defaultProps = {"version":"1.1","id":"Capa_1","x":"0px","y":"0px","width":"430.113px","height":"430.114px","viewBox":"0 0 430.113 430.114","style":{"enableBackground":"new 0 0 430.113 430.114"},"xmlSpace":"preserve"};

module.exports = Facebook;

Facebook.default = Facebook;
